import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children"];
import { useCanRenderNudge } from '../hooks/useCanRenderNudge';
/**
 * The CanRenderNudge component is used to conditionally render its children
 * based on whether the Orchestrator provides the green light to render the nudge.
 *
 * Internally uses the useCanRenderNudge hook to share the same singleton logic.
 */
export const CanRenderNudge = _ref => {
  let {
      children
    } = _ref,
    otherProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    canRender
  } = useCanRenderNudge(otherProps);
  if (!canRender) {
    return null;
  }
  return children;
};